import {billingActionTypes} from "./actionTypes";

export function setBillingData(billingData) {
    return {
        type: billingActionTypes.SET_BILLING_DATA,
        payload: billingData
    }
}

export function setPaymentMethods(paymentMethods) {
    return {
        type: billingActionTypes.SET_PAYMENT_METHODS,
        payload: paymentMethods
    }
}

export function setMicroDepositsBankAccount(microDepositsBankAccount) {
    return {
        type: billingActionTypes.SET_MICRO_DEPOSITS_BANK_ACCOUNT,
        payload: microDepositsBankAccount
    }
}


export function setMicroDepositsBankAccountFailed(accountId) {
    return {
        type: billingActionTypes.SET_MICRO_DEPOSITS_BANK_ACCOUNT_FAILED,
        payload: accountId
    }
}

export function deleteMicroDepositsBankAccount(microDepositsBankAccountId) {
    return {
        type: billingActionTypes.DELETE_MICRO_DEPOSITS_BANK_ACCOUNT,
        payload: microDepositsBankAccountId
    }
}

export function setAccountSummaryCardLoading(value) {
    return{
        type: billingActionTypes.SET_ACCOUNT_SUMMARY_CARD_LOADING,
        payload: value
    }
}

export function setAutoPay(autoPay) {
    return {
        type: billingActionTypes.SET_AUTO_PAY,
        payload: autoPay
    }
}

export function setIsNotAvailableToPay(isNotAvailableToPay) {
    return {
        type: billingActionTypes.SET_IS_NOT_AVAILABLE_TO_PAY,
        payload: isNotAvailableToPay
    }
}